// ts
import dynamic from "next/dynamic";
import { generateUniqueId } from "@/app/utils/string";
import { isMobileDevice } from "@/app/utils/device";

// type
import {
  ChatContentType,
  ComponentTypeEnum,
  CategoryType,
  QuestionType,
  QuestionContentType,
  TagTypeEnum,
  TemplateFlagEnum,
} from "@/app/types/typeConfig/chatQuestion";
import {
  IssueChildrenType,
  IssueItemType,
} from "@/app/types/typeConfig/issueType";
import { ReportParentContentEnum } from "@/app/types/typeConfig/report";

export const requireCustomerQuestionParams = (
  message: string,
): ChatContentType => {
  const template = dynamic(
    () =>
      import(`@/app/components/robot/components/chatTemplate/customerChatItem`),
  );
  return {
    type: ComponentTypeEnum.Customer,
    message,
    data: [],
    uniqueKey: generateUniqueId(),
    template,
  };
};

export const requireRobotQuestionParams = (
  data:
    | CategoryType[]
    | QuestionType[]
    | QuestionContentType
    | IssueChildrenType[],
  path: string,
  {
    type,
    message,
    id,
    issueTypeItem,
    showSubmitTicket,
    title,
    templateFlag = "",
    parentContentInfo,
    showPrinter = false,
    questionName = "",
    printerOperationType = "add",
    rootSourceType,
    templateProps,
    lng,
  }: {
    type: ComponentTypeEnum;
    message?: string;
    id?: string;
    issueTypeItem?: IssueItemType | null;
    showSubmitTicket?: boolean;
    title?: string;
    templateFlag?: number | string;
    parentContentInfo?: {
      parentContent: string;
      parentContentId: string;
      parentContentType: ReportParentContentEnum;
    };
    showPrinter?: boolean;
    questionName?: string;
    printerOperationType?: "add" | "modify";
    rootSourceType?: TagTypeEnum;
    templateProps?: object;
    lng?: string;
  },
): ChatContentType => {
  const template =
    path === TemplateFlagEnum.AnswerQuestion
      ? dynamic(
          () =>
            import(`@/app/components/robot/components/chatTemplate/${path}`),
        )
      : isMobileDevice()
        ? dynamic(
            () =>
              import(
                `@/app/components/robot/components/mobile/chatTemplate/${path}`
              ),
          )
        : dynamic(
            () =>
              import(
                `@/app/components/robot/components/pc/chatTemplate/${path}`
              ),
          );
  return {
    id: id || "",
    title: title || "",
    showSubmitTicket,
    issueTypeItem: issueTypeItem || null,
    type,
    data,
    message,
    uniqueKey: generateUniqueId(),
    template,
    templateFlag: templateFlag || "",
    parentContentInfo: parentContentInfo || {
      parentContent: "",
      parentContentId: "",
      parentContentType: ReportParentContentEnum.DEFAULT,
    },
    showPrinter,
    questionName,
    printerOperationType,
    rootSourceType,
    templateProps,
    lng,
  };
};
